<template lang="pug">
section.sig
    section.sig__pesquisa
        PesquisaInteligente(
            :key='keyBarraPesquisa',
            @representante-selecionado='mostrarTerritoriosRepresentante',
            @territorio-selecionado='mostrarTerritorio',
            @municipio-selecionado='mostrarMunicipio'
        )

        .el-icon-delete.lyra__cartao(
            v-show='pesquisando',
            @click='limparPesquisa'
        )

    section.sig__mapa.lyra__cartao
        mapa(
            ref='mapa',
            idMapa='MapaSig',
            :mapLayersConfigs='camadasMapa',
            :mapConfig='configuracoesMapa',
            :camadaCentralizadaNome='camadaCentralizadaNome',
            :menuMaior='true',
            :atualizarMapa='false'
        )
</template>

<script>
import Mapa from '@/components/MapaLeaflet';
import PesquisaInteligente from '@/components/sig/PesquisaInteligente';
import TerritorioService from '@/services/TerritorioService';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { mapState } from 'vuex';
import L from 'leaflet';

// const ICONE_PONTO_MAPA = L.icon({
//     iconUrl: 'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
//     iconSize: [18, 26]
// });

export default {
    name: 'index',

    components: {
        Mapa,
        PesquisaInteligente
    },

    data() {
        return {
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: true,
                diagnostico: true
            },
            territorios: [],
            territoriosBuffer: [],
            camadaCentralizadaNome: null,
            idMunicipio: null,
            keyBarraPesquisa: 42,
            pesquisando: false
        };
    },

    async created() {
        this.idMunicipio = this.$route.params.idMunicipio;
        if (this.idMunicipio) {
            await this.mostrarMunicipio(this.idMunicipio);
        }
        // } else {
        //     await this.buscarTerritorios();
        // }
    },

    computed: {
        ...mapState(['usuarioLogado'])
    },

    methods: {
        // async buscarTerritorios() {
        //     try {
        //         const { data } = await TerritorioService.findByMapaHome();
        //         this.territorios = data;
        //         this.territoriosBuffer = data;
        //         this.mostrarTerritorios();
        //     } catch (error) {
        //         this.$notify.error({
        //             message: this.$t('mensagens.sig.erro.erroTerritorios')
        //         });
        //     }
        // },

        async buscarTerritorioPorId(id) {
            try {
                const { data } = await TerritorioService.findById(id);
                return data;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.sig.erro.erroTerritorios')
                });
            }
        },

        mostrarTerritorios() {
            this.camadasMapa = [];

            this.territorios.forEach(({ id, centroide, ...informacoes }) => {
                let geoJson = centroide;
                if (typeof centroide === 'string') {
                    geoJson = JSON.parse(geoJson);
                }
                if (geoJson) {
                    this.camadasMapa.push({
                        name: 'centroid' + id,
                        geoJson,
                        icon: L.icon({
                            iconUrl:
                                'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
                            iconSize: [18, 26]
                        }),
                        popup: this.criarPopup({
                            id,
                            ...informacoes
                        }),
                        acaoClick: () => this.mostrarDetalhesTerritorio(id)
                    });
                }
            });
        },

        criarPopup({
            id,
            nome,
            representantes,
            municipio,
            territorioNome,
            municipioNome,
            distritoNome,
            departamentoNome,
            localidades,
            estadoSigla
        }) {
            const nomeTerritorio =
                territorioNome ||
                nome ||
                this.$t('mensagens.sig.erro.naoinformado');
            const nomeMunicipio =
                municipioNome ||
                municipio?.nome ||
                this.$t('mensagens.sig.erro.naoinformado');
            const siglaEstado =
                estadoSigla ||
                municipio?.estado?.sigla ||
                this.$t('mensagens.sig.erro.naoinformado');
            const distrito =
                distritoNome || this.$t('mensagens.sig.erro.naoinformado');
            const departamento =
                departamentoNome || this.$t('mensagens.sig.erro.naoinformado');
            const ambiente = this.usuarioLogado.ambienteLogado;
            const provincia = localidades[1].nome;
            const departamentoAr = localidades[2].nome;

            let representanteLabel = this.$t('mensagens.sig.representante');
            let representanteLista = this.$t(
                'mensagens.sig.erro.nenhumRepresentante'
            );

            if (representantes) {
                if (typeof representantes === 'string') {
                    representantes = representantes.split(',');
                }
                if (
                    Array.isArray(representantes) &&
                    representantes.length > 0
                ) {
                    representanteLabel =
                        representantes.length === 1
                            ? this.$t('mensagens.sig.representante')
                            : this.$t('mensagens.sig.representantes');
                    representanteLista = representantes
                        .map(
                            rep =>
                                rep.nomeRazaoSocial ||
                                this.$t('mensagens.sig.erro.semNome')
                        )
                        .join('<br>');
                }
            }

            const localidade =
                ambiente === 'PY'
                    ? `${distrito} / ${departamento}`
                    : ambiente === 'AR'
                    ? `${departamentoAr} / ${provincia}`
                    : `${nomeMunicipio} / ${siglaEstado}`;

            const conteudoPopup = `
                <h3>${this.$t('mensagens.sig.terrirorio')}:</h3>
                <h4>${nomeTerritorio}</h4>
                <br>
                <h3>${this.$t('mensagens.sig.localidade')}:</h3>
                <h4>${localidade}</h4>
                <br>
                <h3>${representanteLabel}:</h3>
                <h4>${representanteLista || ' - '}</h4>
                <br>
            `;

            const botoes = `
                <div class='btn-visualizar' onclick="window.location.replace('#/territorio/${id}', '_blank'); window.location.reload()">
                    <span>${this.$t('mensagens.sig.visualizar')}</span>
                </div>
                ${
                    ambiente !== 'AR'
                        ? `
                <div class='btn-realizar-diagnostico' onclick="window.location.replace('#/diagnosticos-socioambientais/${id}', '_blank'); window.location.reload()">
                    <i class='flow flow-environment'></i>
                    <span>${this.$t('mensagens.sig.realizarDiagnostico')}</span>
                </div>`
                        : ''
                }
            `;

            return conteudoPopup + botoes;
        },

        async mostrarTerritoriosRepresentante(id) {
            this.pesquisando = true;
            try {
                const { data } =
                    await TerritorioService.buscarTerritoriosPorIdRepresentante(
                        id
                    );
                this.territorios = data;

                if (this.territorios.length > 1) {
                    this.mostrarTerritorios();
                } else {
                    this.mostrarTerritorio(this.territorios[0].id);
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.sig.erro.buscarTerritorioPessoa'
                    )
                });
            }
        },

        async mostrarTerritorio(id) {
            this.pesquisando = true;
            this.camadasMapa = [];

            // eslint-disable-next-line eqeqeq
            const territorio = await this.buscarTerritorioPorId(id);
            let geoJson = territorio.centroide;
            if (typeof geoJson === 'string') {
                geoJson = JSON.parse(geoJson);
            }
            this.camadasMapa.push({
                name: 'centroid' + territorio.id,
                geoJson,
                icon: L.icon({
                    iconUrl: 'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
                    iconSize: [18, 26]
                }),
                popup: this.criarPopup(territorio)
            });

            this.mostrarDetalhesTerritorio(territorio.id);
        },

        async mostrarDetalhesTerritorio(id) {
            this.pesquisando = true;
            const exibindoTerritorio = !!this.camadasMapa.find(
                ({ name }) => name === 'territorioExibido' + id
            );

            if (!exibindoTerritorio) {
                try {
                    const { data } =
                        await TerritorioService.findGeometriaByIdTerritorio(id);

                    this.camadasMapa.push({
                        name: 'territorioExibido' + id,
                        geoJson: data.geometria,
                        style: getEstiloGeometria('area')
                    });
                } catch (error) {
                    this.$notify.error({
                        message: this.$t('mensagens.sig.erro.exbirTerritorio')
                    });
                }
            }

            this.camadaCentralizadaNome = 'territorioExibido' + id;
        },

        async mostrarMunicipio(id) {
            this.pesquisando = true;
            this.camadasMapa = [];

            try {
                const { data } =
                    await TerritorioService.findGeometriaByIdTerritorioLocalidade(
                        id
                    );

                this.camadasMapa.push({
                    name: 'municipio' + id,
                    geoJson: data.geometria,
                    style: getEstiloGeometria('municipio')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.sig.erro.dadosMunicipio')
                });
            }
        },

        limparPesquisa() {
            this.pesquisando = false;
            this.keyBarraPesquisa += 1;
            this.territorios = this.territoriosBuffer;

            this.camadasMapa = [];
        }
    }
};
</script>

<style lang="scss" scoped>
.sig {
    padding: 20px;
}

.sig__mapa {
    border-radius: 5px;
    overflow: hidden;
    height: calc(100vh - 171px);

    position: relative;
    z-index: 1;
}

.sig__pesquisa {
    margin-bottom: 20px;
    display: flex;
    gap: 4px;
}

.el-icon-delete.lyra__cartao {
    width: 40px;
    display: grid;
    place-items: center;
    cursor: pointer;
}
</style>
